import { render } from "./QuadSection.vue?vue&type=template&id=9bda504c"
const script = {}

import "./QuadSection.vue?vue&type=style&index=0&id=9bda504c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__